import { Badge } from "@/components/ui/badge";

export const FaqBlock = ({ faqs }) => (
  <section className="section-padding bg-slate-50" data-testid="faq-block">
    <div className="container-custom max-w-3xl">
      <div className="text-center mb-10">
        <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">FAQ</Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900">Questions fréquentes</h2>
      </div>
      <div className="space-y-4">
        {faqs.map((f) => (
          <div key={f.q} className="bg-white rounded-xl p-6 shadow-sm border border-slate-100">
            <h3 className="font-bold text-lg text-slate-900 mb-2">{f.q}</h3>
            <p className="text-slate-700 leading-relaxed">{f.a}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
